<template>
  <v-container
    fluid>
    <v-row
      justify="center">
      <v-col
        cols="12"
        class="pb-3">
        <v-btn
          :href="statementPDF"
          target="_blank">
          Download Account Statement
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        class="pb-3">
        <v-btn
          v-if="isIOS()"
          :href="taxPDF"
          target="_blank">
          Download Tax Receipt
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn
          v-if="!isIOS()"
          @click="downloadTaxReceipt">
          Download Tax Receipt
        </v-btn>
        <a
          style="display: none;"
          id="taxReceiptDownload"
          :href="'data:application/pdf;base64,' + taxReceiptPDFBase64"
          :download="taxReceiptFilename">download pdf</a>
        <v-btn
          class="ma-2"
          small
          text
          color="primary"
          @click="openTaxDialog">
          Email Tax Receipt
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="showAddOnMessage">
      <v-col>
        <p v-html="accountAddOnMessage"/>
      </v-col>
    </v-row>

    <v-dialog
      v-model="taxReceiptDialog"
      max-width="500px">
      <v-card>
        <v-card-title>Email Tax Receipt</v-card-title>
        <v-divider/>
        <v-row class="pa-2">
          <v-col cols=12>
            <v-text-field
              v-model="caregiverEmailAddress"
              disabled
              outlined
              dense
              hint="If your email is incorrect, please contact the school"
              persistent-hint
            />
          </v-col>

        </v-row>

        <v-card-actions>
          <v-btn
            @click="taxReceiptDialog = false"
          >
            CANCEL
          </v-btn>
          <v-spacer/>
          <v-btn
            @click.stop="sendTaxReceipt()"
            color="primary"
          >
            SEND
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    statement: false,
    numPages: undefined,
    taxReceiptPDFBase64: null,
    statementPDFBase64: null,
    showAddOnMessage: false,
    accountAddOnMessage: '',
    statementPDF: null,
    taxPDF: null,
    taxReceiptDialog: false,
    caregiverEmailAddress: ''

  }),
  onIdle () {
    if (this.$store.state.withPin && this.$store.state.withPin === true) {
      this.$router.push({ path: '/pin', replace: true })
    }
  },
  methods: {
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    sendTaxReceipt: function () {
      this.$http.post('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/sendTaxV2', {
        caregiverEmail: this.caregiverEmailAddress
      })
        .then(resp => {
          this.taxReceiptDialog = false
        })
    },
    openTaxDialog: function () {
      this.taxReceiptDialog = true
    },
    downloadTaxReceipt: function () {
      if (this.taxReceiptPDFBase64 == null) {
        this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/taxReceiptV2')
          .then(resp => {
            this.taxReceiptPDFBase64 = resp.data
            setTimeout(() => {
              const blob = this.b64toBlob(this.taxReceiptPDFBase64, 'application/pdf')
              const url = URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = this.taxReceiptFilename
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }, 250)
          })
      } else {
        const blob = this.b64toBlob(this.taxReceiptPDFBase64, 'application/pdf')
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.taxReceiptFilename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    b64toBlob: (b64Data, contentType = '', sliceSize = 512) => {
      const byteCharacters = atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
  },

  computed: {
    currentDate: function () {
      let a = new Date()
      return a.toDateString().replace(/\s/g, '_')
    },
    taxReceiptFilename: function () {
      return 'TaxReceipt_' + this.$store.getters.pupilFullName.replace(' ', '_') + '_' + this.currentDate + '.pdf'
    },
    statementFilename: function () {
      return 'Statement_' + this.$store.getters.pupilFullName.replace(' ', '_') + '_' + this.currentDate + '.pdf'
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
      vm.$http.get('accountsConfigV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.accountAddOnMessage = resp.data.accountAddOnMessage
          vm.showAddOnMessage = resp.data.showAddOnMessage
        })

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/accountStatementV2')
        .then(resp => {
          vm.statementPDF = resp.data
        })

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/taxStatementV2')
        .then(resp => {
          vm.taxPDF = resp.data
        })

      vm.$http.get('caregiversV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.trueUser + '/caregiverInfoV2')
        .then(resp => {
          if (resp.data.length !== 0) {
            vm.caregiverEmailAddress = resp.data.email
          }
        })

      setTimeout(() => {
        vm.$store.commit('loading', false)
      }, 250)
    })
  }
}
</script>
